import { Star } from "lucide-react";

export const StarRating = ({ value = 0, size = 16, onChange, className = "" }) => {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className={`flex items-center gap-0.5 ${className}`}>
      {stars.map((s) => (
        <button
          key={s}
          type="button"
          disabled={!onChange}
          onClick={() => onChange && onChange(s)}
          className={onChange ? "cursor-pointer transition-transform hover:scale-110" : "cursor-default"}
          data-testid={onChange ? `star-${s}` : undefined}
          aria-label={`${s} star`}
        >
          <Star
            size={size}
            className={s <= Math.round(value) ? "fill-amber-400 text-amber-400" : "fill-slate-200 text-slate-200"}
          />
        </button>
      ))}
    </div>
  );
};
